/** @module polyfills */

/**
 * Ensures support for ES6+ DOM methods
 */
export function dom() {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function(s) {
            let el = this;

            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
    }

    // from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
    [Element.prototype, CharacterData.prototype, DocumentType.prototype].forEach(function(item) {
        if (Object.prototype.hasOwnProperty.call(item, 'remove')) {
            return;
        }

        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                if (this.parentNode === null) {
                    return;
                }

                this.parentNode.removeChild(this);
            },
        });
    });

    if (typeof RadioNodeList === 'undefined') {
        (() => {
            function getRadioNodeListValue() {
                for (let i = 0, len = this.length; i < len; i++) {
                    let el = this[i];

                    if (el.checked) {
                        return el.value;
                    }
                }
            }

            function setRadioNodeListValue(value) {
                for (let i = 0, len = this.length; i < len; i++) {
                    let el = this[i];

                    if (el.checked) {
                        el.value = value;
                        return;
                    }
                }
            }

            Object.defineProperty(HTMLCollection.prototype, 'value', {
                get: getRadioNodeListValue,
                set: setRadioNodeListValue,
                configurable: true,
            });
        })();

        window.RadioNodeList = Object.assign(HTMLCollection);
    }
}
